export default __webpack_public_path__ + "static/media/faq-tablet.02301177.webp";